import axios from "axios";
import { BASE_URL } from "../../_constants/urlConstants";
import { QMS } from "../../_constants/actionConstants";
import { delay } from "../../_utils/generalUtils";
import qs from "qs";

const fakeCmtCategories = [
  {
    cmtCategoryId: 1,
    divisionId: 1,
    label: "Lessons Learned",
    description: "",
  },
  {
    cmtCategoryId: 2,
    divisionId: 1,
    label: "DES Policy Change",
    description: "",
  },
  {
    cmtCategoryId: 3,
    divisionId: 1,
    label: "Specification Changes",
    description: "",
  },
];

const logError = (e) => console.error("ProDMS/QMS: Request failed with error:", e);

const cmtCategoryActions = {
  add: (newCmtCategoryData) => async (dispatch) => {
    dispatch({ type: QMS.CMT_CATEGORY.ADD });
    const apiEndpoint = BASE_URL + "/api/qms/CmtCategory";
    try {
      const res = await axios.post(apiEndpoint, newCmtCategoryData);
      dispatch({
        type: QMS.CMT_CATEGORY.ADD_FULFILLED,
        divisionId: newCmtCategoryData.divisionId,
        cmtCategories: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.CMT_CATEGORY.ADD_REJECTED });
      logError(e);
    }
  },
  update: (cmtCategoryData) => async (dispatch) => {
    dispatch({ type: QMS.CMT_CATEGORY.UPDATE });
    const apiEndpoint = BASE_URL + "/api/qms/CmtCategory";
    try {
      const res = await axios.put(apiEndpoint, cmtCategoryData);
      dispatch({
        type: QMS.CMT_CATEGORY.UPDATE_FULFILLED,
        divisionId: cmtCategoryData.divisionId,
        cmtCategories: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.CMT_CATEGORY.UPDATE_REJECTED });
      logError(e);
    }
  },
  remove: (cmtStageId, divisionId) => async (dispatch) => {
    dispatch({ type: QMS.CMT_CATEGORY.REMOVE });
    const apiEndpoint = BASE_URL + "/api/qms/CmtCategory/" + cmtStageId;
    try {
      const res = await axios.delete(apiEndpoint);
      dispatch({
        type: QMS.CMT_CATEGORY.REMOVE_FULFILLED,
        divisionId,
        cmtCategories: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.CMT_CATEGORY.REMOVE_REJECTED });
      logError(e);
    }
  },
  removeRange: (cmtCategoryIds, divisionId) => async (dispatch) => {
    dispatch({ type: QMS.CMT_CATEGORY.REMOVE });
    const apiEndpoint_delete = `${BASE_URL}/api/qms/CmtCategory`;
    try {
      const delRes = await axios.delete(apiEndpoint_delete, {
        params: { ids: cmtCategoryIds || [] },
        paramsSerializer: (params) => qs.stringify(params),
      });
      if (delRes.data.message) {
        dispatch({ type: QMS.CMT_CATEGORY.REMOVE_FULFILLED });
        // Show alert
        alert(delRes.data.message);
      } else {
        const apiEndpoint_getAll = BASE_URL + "/api/qms/CmtCategory/List/" + divisionId;
        const res = await axios.get(apiEndpoint_getAll);
        dispatch({
          type: QMS.CMT_CATEGORY.REMOVE_FULFILLED,
          divisionId,
          cmtCategories: res.data,
        });
      }
    } catch (e) {
      dispatch({ type: QMS.CMT_CATEGORY.REMOVE_REJECTED });
      logError(e);
    }
  },
  getAllFake: (divisionId) => async (dispatch) => {
    dispatch({ type: QMS.CMT_CATEGORY.FETCH_ALL });

    console.log("Fetching fake cmtCategories for divisionId=", divisionId);
    await delay(800);
    dispatch({
      type: QMS.CMT_CATEGORY.FETCH_ALL_FULFILLED,
      divisionId,
      cmtCategories: fakeCmtCategories,
    });
  },
  getAll: (divisionId) => async (dispatch) => {
    dispatch({ type: QMS.CMT_CATEGORY.FETCH_ALL });
    const apiEndpoint = BASE_URL + "/api/qms/CmtCategory/List/" + divisionId;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({
        type: QMS.CMT_CATEGORY.FETCH_ALL_FULFILLED,
        divisionId,
        cmtCategories: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.CMT_CATEGORY.FETCH_ALL_REJECTED });
      logError(e);
    }
  },
};

export default cmtCategoryActions;
